module.exports = __webpack_public_path__ + "img/face-smile.f282fb26.svg";